export function getQueryParams(name: string) {
  return new URL(window.location.href).searchParams.get(name);
}
